import PageShell from "./PageShell";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";

const Home = () => (
  <PageShell pad={false} title="Strong For Life">
    <Hero />
    <Marquee />
  </PageShell>
);

export default Home;
